import React, { useEffect } from 'react'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import NoReportsFound from '../NoReportsFound'
import RiverPage from 'src/features/river/RiverPage'
import { actions } from '../../MyReportsSlice'
import StorySpinner from 'src/components/StorySpinner'
import Page from 'src/components/Page'

const ProfileReports = props => {
  const dispatch = useDispatch()
  const { loading = null, data: reportsCount } = useSelector(
    state => state.myReportsReducer.count,
    shallowEqual
  )

  useEffect(() => {
    dispatch(actions.requestReportsCount())
  }, [])

  if (loading !== false) {
    return (
      <Page>
        <StorySpinner />
      </Page>
    )
  }

  if (reportsCount && reportsCount > 0) {
    return <RiverPage />
  }
  return <NoReportsFound {...props} />
}

ProfileReports.propTypes = {}

export default ProfileReports
